import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DoubleArrowLeft from '../Icons/DoubleArrowLeft';
import SingleArrowLeft from '../Icons/SingleArrowLeft';
import IconButton from 'material-ui/IconButton';
import { addCommas } from '../../utils/utils'
import { KEYMAN_LIST_DISPLAY_LIMIT } from '../../constants/Constants'

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },

  paginationRoot: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  iconBtn: {
    height: '36px',
    width: 'unset',
    minWidth: 'unset',
    minHeight: 'unset',
    margin: '0px 3px',
    padding: '9px 14px',
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    borderRadius: '2px',

    '&:hover': {
      '&:before': {
        content: '""',
        width: '100%',
        height: '100%',
        position: 'absolute',
        left: 0,
        top: 0,
        pointerEvents: 'none',
        background: 'rgba(0, 0, 0, 0.16)',
      }
    }
  },

  pages: {
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    '& li': {
      fontSize: '16px',
      height: '36px',
      padding: '8px 14px',
      background: '#FFFFFF',
      border: '1px solid #D8DBDF',
      listStyle: 'none',
      margin: '0px 3px',
      boxSizing: 'border-box',
      position: 'relative',
      cursor: 'pointer',

      ['@media only screen and (max-width: 768px)']: { // eslint-disable-line no-useless-computed-key
        fontSize: '12px',
        padding: '5px 7px',
        margin: '0px 2px',
      },

      '&:hover': {
        '&:before': {
          content: '""',
          width: '100%',
          height: '100%',
          position: 'absolute',
          left: 0,
          top: 0,
          pointerEvents: 'none',
          background: 'rgba(0, 0, 0, 0.16)',
        }
      }
    }
  },

  dot: {
    background: 'none !important',
    border: 'none !important',
    pointerEvents: 'none',
    lineHeight: 'calc(36px - 16px)',
  },

  currentPage: {
    pointerEvents: 'none',
    color: '#B1B3B9 !important',
    background: '#F0F2F4 !important',
  },

  notification: {
    color: '#71737B',
    border: '1px solid #D8DBDF',
    background: '#ECEEF0',
    borderRadius: '2px',
    padding: '20px 10px',
    marginBottom: '30px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    fontSize: '13px',
    fontWeight: 'bold',
  },

  desc: {
    fontSize: '12px',
    color: "#71737B",
    marginTop: '13px',
  }
});

class Pagination extends React.Component {
  goToPage = (page) => () => {
    this.props.onChange({
      'per_page': this.props.perPage,
      'page': page
    })
  }

  renderPageBtn = (page, handleClick = null) => {
    const { classes, currentPage, disableNavigation, togglePlanDialog } = this.props;

    return (
      <li
        key={page}
        onClick={handleClick ? handleClick : (disableNavigation ? togglePlanDialog : this.goToPage(page))}
        className={(currentPage === page) ? classes.currentPage : ''}>
        {page}
      </li>
    )
  }

  calcLastPage = () => {
    const { perPage, lastPage, total } = this.props;

    // ESが1万件超えるとエラーが出るので
    if (total <= KEYMAN_LIST_DISPLAY_LIMIT) {
      return lastPage;
    } else {
      return Math.floor(KEYMAN_LIST_DISPLAY_LIMIT / perPage);
    }
  }

  render() {
    const { classes, disabled, currentPage, showLastPage, lastPage, perPage, disableNavigation, togglePlanDialog } = this.props;

    const displayItemCount = 5;
    const lastPageToDisplay = this.calcLastPage();
    const shouldShowCappedMessage = (
      !showLastPage
      && currentPage === lastPageToDisplay
      && lastPage > lastPageToDisplay
    );

    const maxPageCount = 3
    const firstIndex = 1;
    const secondIndex = 2;
    const thirdIndex = 3;
    const fourthIndex = 4;
    const showLastPageArrayCount = 3;
    const notShowLastPageArrayCount = 5;

    return (
      <div className={classes.root} style={{ pointerEvents: disabled ? 'none' : 'auto' }}>
        <div>
          {(() => {
            if (shouldShowCappedMessage) {
              return (
                <div className={classes.notification}>{addCommas(KEYMAN_LIST_DISPLAY_LIMIT)}件目以降のアイテムは仕様上の都合により表示できません。表示設定から並び順を変更するか、検索条件を追加してください。</div>
              )
            }
          })()}

          <div className={classes.paginationRoot}>
            {(currentPage > 1 && lastPageToDisplay > displayItemCount) && (
              <IconButton className={classes.iconBtn} onClick={disableNavigation ? togglePlanDialog : this.goToPage(1)}>
                <DoubleArrowLeft color="#71737B" height={16} width={16} />
              </IconButton>
            )}

            {(currentPage > 1 && lastPageToDisplay > displayItemCount) && (
              <IconButton className={classes.iconBtn} onClick={disableNavigation ? togglePlanDialog : this.goToPage(currentPage - 1)} style={{ margin: '0px 6px 0px 3px' }}>
                <SingleArrowLeft color="#71737B" height={16} width={16} />
              </IconButton>
            )}

            {(() => {
              if (lastPageToDisplay <= displayItemCount) {
                return (
                  <ul className={classes.pages}>
                    {Array.from(Array(lastPageToDisplay).keys()).map(i => this.renderPageBtn(i + 1))}
                  </ul>
                )
              } else {
                if (showLastPage) {
                  return (
                    <ul className={classes.pages}>
                      {this.renderPageBtn(1)}

                      {currentPage > maxPageCount && (<li className={classes.dot}>⋯</li>)}

                      {(() => {
                        let num = 0;
                        if (currentPage === firstIndex) {
                          num = 1;
                        } else if (currentPage === secondIndex) {
                          num = 0;
                        } else if (currentPage > secondIndex && currentPage < lastPage - 1) {
                          num = -firstIndex;
                        } else if (currentPage === lastPage - 1) {
                          num = -secondIndex;
                        } else if (currentPage === lastPage) {
                          num = -thirdIndex;
                        }

                        return Array.from(Array(showLastPageArrayCount).keys()).map(i => this.renderPageBtn(currentPage + i + num));
                      })()}

                      {currentPage < lastPage - secondIndex && (<li className={classes.dot}>⋯</li>)}

                      {this.renderPageBtn(lastPage)}
                    </ul>
                  )
                } else {
                  return (
                    <ul className={classes.pages}>
                      {currentPage > maxPageCount && (<li className={classes.dot}>⋯</li>)}

                      {(() => {
                        let num = 0;
                        if (currentPage === firstIndex) {
                          num = 0;
                        } else if (currentPage === secondIndex) {
                          num = -firstIndex;
                        } else if (currentPage > secondIndex && currentPage < lastPageToDisplay - 1) {
                          num = -secondIndex;
                        } else if (currentPage === lastPageToDisplay - 1) {
                          num = -thirdIndex;
                        } else if (currentPage === lastPageToDisplay) {
                          num = -fourthIndex;
                        }

                        return Array.from(Array(notShowLastPageArrayCount).keys()).map(i => this.renderPageBtn(currentPage + i + num));
                      })()}

                      {currentPage < lastPageToDisplay - secondIndex && (<li className={classes.dot}>⋯</li>)}
                    </ul>
                  )
                }
              }
            })()}

            {(currentPage < lastPageToDisplay && lastPageToDisplay > displayItemCount) && (
              <IconButton className={classes.iconBtn} onClick={disableNavigation ? togglePlanDialog : this.goToPage(currentPage + 1)} style={{ margin: '0px 3px 0px 6px' }}>
                <SingleArrowLeft color="#71737B" height={16} width={16} style={{ transform: 'rotate(-180deg)' }} />
              </IconButton>
            )}

            {(currentPage < lastPageToDisplay && lastPageToDisplay > displayItemCount) && (
              <IconButton className={classes.iconBtn} onClick={disableNavigation ? togglePlanDialog : this.goToPage(lastPageToDisplay)}>
                <DoubleArrowLeft color="#71737B" height={16} width={16} style={{ transform: 'rotate(-180deg)' }} />
              </IconButton>
            )}
          </div>
        </div>
        <div className={classes.desc}>
          検索結果 {addCommas(this.props.total)}件中　{addCommas((currentPage - 1) * perPage + 1)}件目~{addCommas(currentPage * perPage <= this.props.total ? currentPage * perPage : this.props.total)}件目を表示
        </div>
      </div>
    )
  }
}

Pagination.propTypes = {
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
  lastPage: PropTypes.number,
  perPage: PropTypes.number,
  total: PropTypes.number,
  disableNavigation: PropTypes.bool,
  togglePlanDialog: PropTypes.func,
  disabled: PropTypes.bool,
  showLastPage: PropTypes.bool,
};

export default withStyles(styles)(Pagination);



// WEBPACK FOOTER //
// ./src/components/common/Pagination.jsx